/**
 * Session storage key for JWT access token (must match auth interceptor).
 *
 */
export const LUMEN_ACCESS_TOKEN_KEY = 'lumen_access_token';
